import React from 'react';
import { Tooltip as AntTooltip } from 'antd';

const Tooltip = ({ className, children }) => {
  return (
    <AntTooltip placement="top" title={children}>
      <span className={`st-slider-field--helper ${className || ''}`}>?</span>
    </AntTooltip>
  );
};

export default Tooltip;
